/**
 * NicLen.Backend API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type DriverState = 'NotDispatched' | 'Notified' | 'Read' | 'Confirmed';

export const DriverState = {
    NotDispatched: 'NotDispatched' as DriverState,
    Notified: 'Notified' as DriverState,
    Read: 'Read' as DriverState,
    Confirmed: 'Confirmed' as DriverState
};

